export default __webpack_public_path__ + "static/media/videoLayoutIcon 2.f89a4b85.svg";